import {BylineComponent} from './BylineComponent'
import './scss/byline.scss'

const BylinePackage = {
    name: 'UIByline',
    configure: function(config) {
        config.addComponent('UIByline', BylineComponent, false, 'BylineComponent')

        config.addLabel('Add to byline', {
            sv: 'Lägg till byline'
        })

        config.addLabel('Add to image byline', {
            sv: 'Lägg till byline'
        })

        config.addLabel('Remove', {
            sv: 'Ta bort'
        })
    }
}

export {BylinePackage}
